import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
export interface ILeadGridFormatterTemplateExtraStyles {
  justifyContent?: 'start' | 'center' | 'end';
}

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: ${(props: ILeadGridFormatterTemplateExtraStyles) =>
    props.justifyContent ? props.justifyContent : 'center'};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 3px;
`;

export const LeadNavLink = styled(NavLink)`
  text-decoration: none;
  color: inherit;
  &:hover {
    text-decoration: underline;
  }
`;
